import React from 'react'

import "../../../css/Tables.css"
export const Table = ({ children, style = '' }) => {
  return (
    <div className={`${style.contet_table?`${style.contet_table}`:'tableFixHead'} scroll-menu`}>
      <table className={`${style.table?`${style.table} admin-table`:'admin-table'}`}>
        {children}
      </table>
    </div>
  )
}
